/* eslint-disable */

import React from "react";
import moment from "moment";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Popconfirm } from "antd";

const BannerItem = ({ data, onDelete, onSelect }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: data.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="group tw-flex tw-flex-col tw-gap-4 tw-max-w-[700px] tw-w-full tw-bg-white tw-rounded-2xl tw-shadow-lg tw-overflow-hidden tw-cursor-grab tw-relative"
      {...attributes}
      {...listeners}
    >
      <img
        src={data.image}
        className="tw-w-full tw-object-cover tw-h-[200px]"
      />

      <div className="tw-flex tw-flex-col tw-p-4 tw-gap-2">
        <p className="tw-font-bold tw-text-3xl tw-m-0">{data.description}</p>

        <div className="tw-grid tw-grid-cols-2">
          <span>
            Publish date: {moment(data.start_date).format("DD/MM/YYYY, HH:mm")}
          </span>
          <span>
            End date:{" "}
            {data.end_date
              ? moment(data.end_date).format("DD/MM/YYYY, HH:mm")
              : "N/A"}
          </span>

          {data.payload && (
            <span className="tw-col-span-2">
              Navigation: {data.payload.screen} - {data.payload.to}
            </span>
          )}
        </div>
      </div>

      <div className="tw-bg-white tw-p-2 tw-gap-2 tw-flex tw-flex-row tw-shadow-md tw-rounded-md tw-absolute tw-top-4 tw-right-4 group-hover:tw-bg-red-600">
        <button
          className="tw-border-none tw-text-blue-500 tw-bg-white tw-cursor-pointer"
          onClick={() => onSelect()}
        >
          Edit
        </button>

        <Popconfirm
          title="Are you sure to delete this one?"
          onConfirm={() => onDelete()}
          okText="Yes"
          cancelText="No"
        >
          <button className="tw-border-none tw-pointer-events-auto tw-text-primary tw-bg-white tw-cursor-pointer">
            Delete
          </button>
        </Popconfirm>
      </div>
    </div>
  );
};

export default BannerItem;
